import { Flex } from 'antd';
import { activationProps } from '../common/activationProps';
import { CardContainer } from '../../assets/styles/components/worktime.styled';
import { Heading, Paragraph } from '../Ant';
import { ArrowRight, Briefcase } from '../icons';
import { useNavigationStack } from '../../context/NavigationStackContext';
import { LOCAL_STORAGE_NAMES, ROUTES, ThemeMode } from '../../constants/constants';
import { rgbToRgba, workTimeFallBackColor } from '../../constants/utilityFunctions';
import { useTranslation } from 'react-i18next';
import { hasGoodContrast } from '../../helpers/colorContrastRatioHelper';
import { themes } from '../config/variables';

interface WorktimeCardProps {
  title: string;
  description?: string;
  id: string;
  color?: string;
  headingclass?: string;
  currentOfTotalDays?: string;
}

const WorktimeCard = ({
  title,
  description,
  id,
  color,
  headingclass,
  currentOfTotalDays,
}: WorktimeCardProps) => {
  const { t } = useTranslation();
  const { push } = useNavigationStack();
  const storedTheme = localStorage.getItem(LOCAL_STORAGE_NAMES.theme);
  const handleWorkTimeDetail = (workTimeId: string) => {
    push(ROUTES.WORK_TIME_DETAIL + `/${workTimeId}`);
  };
  let workTimeSubject = title?.trim() || '';

  if (currentOfTotalDays) {
    workTimeSubject = `(${t('common:day')} ${currentOfTotalDays}) ${title?.trim()}`;
  }
  const workTimeColor = color ?? workTimeFallBackColor(storedTheme as ThemeMode);
  const isLightTheme = storedTheme === ThemeMode.light.toLowerCase();
  const lightBackgroundColor = `rgb(${themes['light']['clr-container-bg']})`;
  let borderColor = workTimeColor;
  if (isLightTheme && !hasGoodContrast(workTimeColor, lightBackgroundColor)) {
    borderColor = '#E3E3E3';
  }
  return (
    <CardContainer
      gap={5}
      data-testid="worktime-card"
      className="w-full overflow-hidden"
      style={{
        backgroundColor: rgbToRgba(workTimeColor, 0.1) as string,
        border: `1px solid ${borderColor}`,
      }}
      vertical
      {...activationProps(() => handleWorkTimeDetail(id))}
    >
      <Flex gap={10} justify="space-between" align="center">
        <Heading
          level={6}
          data-testid="worktime-card-title"
          $fontsize="13px"
          $lineheight="20px"
          $color="title"
          className={`lineclamp-1 ${headingclass}`}
          $width="fit-content"
        >
          {workTimeSubject}
        </Heading>
        <ArrowRight className="fs-18" />
      </Flex>
      {description && (
        <Flex gap={5} align="center" className="description-container">
          <Briefcase className="fs-14" />
          <Paragraph
            data-testid="worktime-card-description"
            $fontsize="11px"
            $color="description"
            $lineheight="17px"
            className="lineclamp-1"
            $width="fit-content"
          >
            {description}
          </Paragraph>
        </Flex>
      )}
    </CardContainer>
  );
};

export default WorktimeCard;
